// src/components/common/PublicFooter.js — 공개 사이트 공통 푸터
import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, companyInfoRows } from '../../config/company';
import './PublicFooter.scss';

const PublicFooter = () => {
  const info = companyInfoRows();
  return (
    <footer className="public-footer">
      <div className="gt-container">
        <div className="public-footer__top">
          <div className="public-footer__brand">
            <Link to="/" className="public-footer__logo">GATEON</Link>
            <p>예매부터 입장까지, 게이트온</p>
            <p className="public-footer__contact">
              <a href={`tel:${COMPANY.phone}`}>{COMPANY.phone}</a>
              <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            </p>
          </div>

          <nav className="public-footer__cols" aria-label="사이트 안내">
            <div>
              <h2>행사 운영</h2>
              <Link to={{ pathname: '/', hash: '#features' }}>기능</Link>
              <Link to={{ pathname: '/', hash: '#pricing' }}>요금</Link>
              <Link to="/demo">데모 행사</Link>
              <a href="/blog">블로그</a>
              <Link to="/business/signup">무료로 시작하기</Link>
            </div>
            <div>
              <h2>티켓 예매</h2>
              <Link to="/lookup">예약 조회</Link>
              <Link to="/login">로그인</Link>
              <Link to="/register">회원가입</Link>
            </div>
            <div>
              <h2>고객지원</h2>
              <Link to="/faq">자주 묻는 질문</Link>
              <Link to="/notices">공지사항</Link>
              <Link to="/contact">도입 상담 신청</Link>
              <Link to="/admin/login">운영자 로그인</Link>
            </div>
          </nav>
        </div>

        <div className="public-footer__bottom">
          <div className="public-footer__legal">
            <Link to="/terms">이용약관</Link>
            <Link to="/privacy" className="is-strong">개인정보처리방침</Link>
          </div>
          {info.length > 0 && (
            <dl className="public-footer__info">
              {info.map(([k, v]) => (
                <div key={k}><dt>{k}</dt><dd>{v}</dd></div>
              ))}
            </dl>
          )}
          <p className="public-footer__copy">© {new Date().getFullYear()} GATEON</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
